<template>
    <div class="sub-nav-item" :class="rootClasses">
        <a :href="child.path" class="u-reset sub-nav-item--link"
                :class="btnClasses"
                @click="onMenuItemClick($event)">
            <span class="sub-nav-item--text" v-html="child.label"></span>
        </a>
    </div>
</template>

<script>
    import { touchevents } from 'modernizr';
    import { get } from 'lodash';
    import interactiveNavItemMixin from 'vue/mixins/interactive-nav-item';


    export default {
        mixins: [interactiveNavItemMixin],
        computed: {
            hasFlyout() {
                return this.child.flyout;
            },
            rootClasses() {
                return [
                    `sub-nav-item__${ this.facet }`,
                ];
            },
            btnClasses() {
                const { idx } = get(this.navigation, `[${ this.level }]`, {});
                const isActive = (idx === this.idx);

                return [
                    `sub-nav-item--link__col`,
                    `sub-nav-item--link__col-${ this.child.color || 'neutral' }`,
                    this.hasContent ? '' : 'sub-nav-item--link__allow-link-hover',
                    (isActive && this.hasContent) ? 'sub-nav-item--link__is-active' : '',
                ];
            },
        },
        methods: {
            // NOTE: This will be triggered from the parent
            onItemHover(toggle) {
                if (!touchevents) {
                    this.updateNav(toggle);
                }
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2ba9d105